export const ListQueryKey = 'projectInnerTransConfigs';
export const DetailQueryKey = 'projectInnerTransConfig';
export const Urls = {
  selectUrl: '/innerTransConfig/list',
  updateUrl: '/innerTransConfig/update',
  deleteUrl: '/innerTransConfig/delete',
  createUrl: '/innerTransConfig/create',
  detailUrl: '/innerTransConfig/info'
};